<template>
  <div class='report-item report-item--heading brand-background-color' :style='theme'>
    <div class="text">
      <div class="logo-container" v-if='this.config.logo' >
        <img :src='this.config.logo' class='logo'/>
      </div>
      <ContentEditable :style='{color: titleColor}' class='content-title brand-title-color' tag='h1' :html='true' :editable='editable' v-model='content.title' :font-scale='titleFontSize' :translated='$t(content.title, "title", this.tag)'></ContentEditable>
      <ContentEditable :style='{color: textColor}' class='content-subtitle brand-text-color' tag='h2' :font-scale='textFontSize' :html='true' :editable='editable' placeholder='Subtitle' v-model='content.subtitle' :translated='$t(content.subtitle, "subtitle", this.tag)'></ContentEditable>
      <UIActions v-if='editable' :buttons='buttons' @delete='onDelete' @add='onAdd' @edit='onEdit'></UIActions>
    </div>
  </div>
</template>
<script>
import UIActions from './UIActions.vue'
import ContentEditable from '../../ContentEditable.vue'
import _ from 'lodash';
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: {
    config: {default: ()=>{{}}, type: Object},
    editable: {default: true, type: Boolean},
    report: {default: ()=>{{}}, type: Object},
    response: {default: ()=>{{}}, type: Object}
  },
  mixins: [TranslationMixin],
  inject: ['globalTheme'],
  data () {
    return {
      content: {},
      ready: false,
      buttons: ['edit', 'add', 'delete']
    }
  },
  components: {
    UIActions,
    ContentEditable
  },
  methods: {
    onEdit () {
      this.$emit('edit', {
        target: this,
        fields: null,
        editorClass: 'HeadingEditPanel'
      })
    },
    onAdd () {
      this.$emit('add')
    },
    onDelete () {
      this.$emit('delete')
    }
  },
  computed: {
    theme () {
      let themeOptions = {
        backgroundPosition: this.backgroundPosition,
        backgroundColor: this.computedBackgroundColor
      }
      if (this.config.image){
        themeOptions.backgroundImage = "url('" +this.config.image+ "')"
      }
      return themeOptions;
    },
    computedBackgroundColor () {
      if (!this.globalTheme.campaign) {
        return this.config.theme.backgroundColor
      }
      return this.config.theme.backgroundColor || this.globalTheme.campaign.secondary.backgroundColor
    },
    backgroundPosition () {
      const x = 50
      const y = this.config.theme.backgroundVertical || 50
      return `${x}% ${y}%`
    },
    titleColor () {
      if (!this.globalTheme.campaign) {
        return this.config.theme.titleColor
      }
      return this.config.theme.titleColor || this.globalTheme.campaign.secondary.color || null
    },
    textColor () {
      if (!this.globalTheme.campaign) {
        return this.config.theme.textColor
      }
      return this.config.theme.textColor || this.globalTheme.campaign.secondary.color || null
    },
    titleFontSize () {
      let size = this.config.theme.titleFontSize || this.globalTheme.titleFontSize || 100
      return size
    },
    textFontSize () {
      let size = this.config.theme.textFontSize || this.globalTheme.textFontSize || 100
      return size
    }
  },
  created () {
    this.content = this.config
    if (typeof this.config.deletable !== 'undefined' && this.config.deletable === false) {
      this.buttons = ['edit', 'add']
    }
    this.save = _.debounce(function(){
      if (!this.editable) {
        return
      }
      this.$store.dispatch('saveItem', this.config)
    }, 500)
  },
  mounted () {
    //this.ready = true
  },
  watch: {
    content: {
      handler: function(content){
        if (!this.ready){
          this.ready = true
          return
        }
        this.$store.commit('setDirty', true)
        this.save()
      },
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
  @import '../../../../scss/components/variables';
  @import '../../../../scss/components/form';
  @import '../scss/report_items';
  .report-item--heading {
    min-height: 200px;
    background-size: cover;
    .logo {
      max-width: 100%;
      display: inline-block;
      margin-bottom: 1rem;
    }
    .text {
      padding: 2rem 0;
      ::v-deep h1 {
        font-size: 250%;
      }
      min-height: 200px;
    }
  }
  @media screen and (min-width: 768px) {
    .report-item--heading {
      min-height: 300px;
      .text {
        padding: 3rem 0;
        min-height: 300px;
      }
    }
  }
  @media screen and (min-width: 920px) {
    .report-item--heading {
      min-height: 400px;
      .text {
        min-height: 400px;
      }
    }
  }
</style>